import React from 'react';
import './mid.css';
import lg from '../images/ecell.PNG';

const Mid = () => {
    return (
        <div className='mid'>
            <img src={lg} alt="" />
            <h1>
                <span >THE <span className='color'>ENTREPRENEURSHIP</span> CELL</span>
            </h1>
            <h1>
                 <span id="hell"><span className='color'>Jabalpur</span > Engineering <span className='color'>College</span></span> 
            </h1>
        </div>
    );
}

export default Mid;
